import { forwardRef, type Ref, type SVGProps } from "react";
const IconDirectionsFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m29.42 14.6-12-12a2 2 0 0 0-2.8 0l-12 12a2 2 0 0 0 0 2.8l12 12a2 2 0 0 0 2.8 0l12-12a2 2 0 0 0 0-2.8m-7.6.87-3.66 4.19a1 1 0 0 1-.74.34 1 1 0 0 1-.74-1.66l2-2.34H12v2a1 1 0 0 1-1 1 1 1 0 0 1-1-1v-2.61A1.39 1.39 0 0 1 11.39 14h7.33l-2-2.34a1 1 0 0 1 .08-1.41 1 1 0 0 1 1.4.09l3.66 4.19a.7.7 0 0 1-.04.94" />
  </svg>
);
const ForwardRef = forwardRef(IconDirectionsFilledSVG);
ForwardRef.displayName = "IconDirectionsFilled";
export { ForwardRef as IconDirectionsFilled };
